import { get } from 'lodash';
import { isGa2Device } from 'common/utils/deviceTwinUtils';

export const getCounterSuffix = (donor, activeDeviceId) => {  
  if (!donor || !isGa2Device(donor)) return '';

  if (activeDeviceId === '') return '_/du'

  const units = get(donor, 'properties.reported', null);
  if (!units) return '';

  for (const [name, data] of Object.entries(units)) {
    const unitId = get(data, 'inventory-info.serial-id', '');
    if (unitId === activeDeviceId) {
      const suffix = `_/${name.toLowerCase()}`;
      return suffix;
    }
  }

  return '';
};
